import { extractUniqueTags } from './extractUniqueTags';
import { swapTags } from './swapTags';
import { IPersonalizationTag, PersonalizationSwapTagsMode } from '../types/personalization';

export const tagProcessing = (text: string, tagsAndValues: IPersonalizationTag[], mode: PersonalizationSwapTagsMode): string => {
    try {
        if (mode === PersonalizationSwapTagsMode.NONE) {
            return text;
        }

        const uniqueTags = extractUniqueTags(text);
        const usedTags = tagsAndValues.filter(({ tag }) => uniqueTags.includes(tag));

        let processedText = text;
        usedTags.forEach(({ tag, value, fallback }) => {
            processedText = swapTags(processedText, tag, mode === PersonalizationSwapTagsMode.VALUE ? value : fallback, fallback)
        });

        return processedText;
    } catch (err) {
        throw new Error(`Could not process personalization tag: ${err}`);
    }
};
